import {Component, OnInit} from '@angular/core';
import {CommonComponent} from '../../shared/common/common.component';
import {LocalStorageService} from 'angular-2-local-storage';
import {AccountService} from '../../../services/account.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {NgForm} from '@angular/forms';
import {ToastaService} from 'ngx-toasta';
import {AuthenticationService} from '../../../services/authentication.service';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {DialogService} from 'primeng/dynamicdialog';

@Component({
  selector: 'app-password-change',
  templateUrl: './password-change.component.html',
  styleUrls: ['./password-change.component.scss']
})
export class PasswordChangeComponent extends CommonComponent implements OnInit {
  password: string = null;
  newPassword: string = null;
  newPasswordConfirm: string = null;

  showPassword: boolean;
  showNewPassword: boolean = true;
  showNewPasswordConfirm: boolean = true;

  passwordMinLength: boolean;
  passwordCapsLower: boolean;
  passwordNumber: boolean;
  passwordSpecial: boolean;
  passwordSpaces: boolean;
  passwordSequences: boolean;
  passwordRepetition: boolean;

  constructor(
    protected router: Router,
    private localStorageService: LocalStorageService,
    private accountsService: AccountService,
    private authenticationService: AuthenticationService,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    public translate: TranslateService,
    protected dialogService: DialogService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
  }

  ngOnInit(): void {
  }

  submit(form: NgForm) {
    this.loadingModalOn();
    this.accountsService.passwordChange(this.password, this.newPassword, this.newPasswordConfirm).subscribe(
      (response: any) => {
        this.loadingModalOff();
        this.msgSuccess(this.translate.instant('accounts.password_change.message_success'));
        form.resetForm();
        this.password = null;
        this.newPassword = null;
        this.newPasswordConfirm = null;
        this.logout();
      }, error => {
        this.msgError(error);
        this.loadingModalOff();
      }
    );
  }

  handleBlurPassword() {
    setTimeout(() => {
      this.showPassword = false;
    }, 100);
  }

  handleBlurChangePass(param: string) {
    setTimeout(() => {
      param === 'first' ? this.showNewPassword = false : this.showNewPasswordConfirm = false
    }, 100);
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }

  passwordValidation() {
    if (this.newPassword) {
      this.passwordMinLength = this.newPassword?.length >= 8 && this.newPassword?.length <= 128;
      this.passwordCapsLower = this.passwordCapsValidation(this.newPassword) && this.passwordLowerCaseValidation(this.newPassword);
      this.passwordNumber = this.passwordNumberValidation(this.newPassword);
      this.passwordSpecial = this.passwordSpecialValidation(this.newPassword);
      this.passwordSequences = !this.passwordSequencesValidation(this.newPassword);
      this.passwordRepetition = this.passwordRepetitionValidation(this.newPassword);
      this.passwordSpaces = this.passwordSpacesValidation(this.newPassword);
    }
  }
}
